import React from "react";
import {
  flashSaleSoldOut,
  getFinalProductAmount, getSafeDiscount,
  parseFloatSafe,
  safeImage, toFixed
} from "../../../../helpers/helperFunctions";
import CustomIcon from "../../../../components/CustomIcon";
import {capitalizeFirstLetter} from "../../../../helpers/stringHelper"
import {ReactComponent as StarSvg} from "../../../../assets/img/svgs/star.svg";
import {ReactComponent as StarFillSvg} from "../../../../assets/img/svgs/star_fill.svg";
import {ReactComponent as StarHalfSvg} from "../../../../assets/img/svgs/star_half_fill.svg";
import {ReactComponent as HeartSvg} from "../../../../assets/img/svgs/heart.svg";
import { DangerButton } from "components/CustomButton";
import { ProductCardTags } from "./ProductCardTag";


const ProductCard = ({product, mobile, isFlashSale, onRemove, isHorizontal= false, hideButton= false}) => {


  const safeDiscount = getSafeDiscount(product.discount);
  //roundedSafeDiscount is just for the display not for the calculations
  const roundedSafeDiscount = Math.round(safeDiscount)
  const discountedPrice = safeDiscount ?
    getFinalProductAmount(product.selling_price_without_vat, safeDiscount, product.tax) : product.price;

  const isSoldOut = product?.sold_out || product?.price <= 0;
  const isFlashSaleSoldOut = flashSaleSoldOut(product);


  return (
    isHorizontal ?
    <div className="flex space-x-4 items-center">
      <div className="flex space-x-4 items-start w-full border p-3 rounded bg-white">
        <img className="object-contain aspect-product-image w-14 border rounded bg-rand-500" src={safeImage(product.image)} alt={product?.label}/>
        <div className="flex-1">
            <div className="flex justify-between space-x-4">
              <div>
              <span className={`leading-none ${mobile ? "text-xs h-8" : "text-base"}`}>{capitalizeFirstLetter(product.label)} </span>
              {!!roundedSafeDiscount && <span
              className="text-white font-bold bg-rand-100 rounded-full text-xxs leading-none py-1 px-1.5 whitespace-nowrap">{roundedSafeDiscount} % off
                </span>}</div>
              {(isSoldOut || product.disabled || isFlashSaleSoldOut) && <div
                className={`${mobile ? "text-xxs" : "text-sm"} text-error-500 font-medium shrink-0`}>
                {isSoldOut ? 'Out of Stock' : product.disabled ? 'Not Available' : isFlashSaleSoldOut ? 'Sold Out' : 'Stock not Available'}
              </div>}
            </div>
            {
              product.has_variants &&
            <div className="text-xs text-neutral-darkest font-light">{Object.entries(product.variant_values).map(([k,v]) => `${k}:${v} `)}</div>
            }
            <div className="flex items-end space-x-2 mt-1.5">
              <span className={`${mobile ? "text-xs leading-none" : "text-base leading-none"} text-primaryApp font-medium`}>NPR. {discountedPrice}</span>
                 {!!roundedSafeDiscount &&
                <span className="line-through text-xs leading-none">NPR. {product.price}</span>
              }
            </div>
        </div>
      </div>
      {onRemove && (
        <DangerButton onClick={onRemove} isIconButton={true}>
          <CustomIcon icon="delete"/>
        </DangerButton>
      )}
      </div>
    :
    <div className="product-size border bg-white app-rounded relative shrink-0 overflow-hidden">

      {onRemove && (
        <div className="absolute right-[-5px] rounded-2xl p-2 bg-gray-300 z-30 cursor-pointer h-8 w-8 " onClick={onRemove}>
          <CustomIcon icon={'close'} size="xl" className="absolute"/>
        </div>
      )}
      <div className="relative flex items-center justify-center aspect-product-image w-full">
        <img className="object-contain w-full h-full" src={safeImage(product.image)} alt={product?.label}/>        
        <ProductCardTags product={product}/>
        <ProductCardStarWidget reviewAndRating={product?.review_and_rating} className="absolute left-0 bottom-0" mobile={mobile}/>
        {(isSoldOut || product.disabled || isFlashSaleSoldOut) && <div
          className={`${mobile ? "text-xxs" : "text-base"} border-primaryApp border-solid border-2 bg-white bg-opacity-80 rounded-full text-primaryApp px-2 absolute top-1/2 text-center`}>
          {isSoldOut ? 'Out of Stock' : product.disabled ? 'Not Available' : isFlashSaleSoldOut ? 'Sold Out' : 'Stock not Available'}
        </div>}
      </div>

      <div className="h-0.5 bg-tPrimary-400"/>
      <div className={`overflow-hidden text-dark ${mobile ? "p-2" : "p-3"}`}>
        <div
          className={`text-2-clamp leading-[1.2] ${mobile ? "text-xs h-8" : "text-lg h-[44px]"}`}>{capitalizeFirstLetter(product.label)}</div>       
      
        <div className={`${mobile ? "text-xs" : "text-lg"} text-center`}>

            <span className="text-primaryApp leading-none"><span
              className={`${mobile ? "text-xxs font-medium" : "text-sm font-normal"}`}>NPR. </span>{discountedPrice}</span>
          {!!roundedSafeDiscount && <span
            className="text-primaryApp font-bold border-l border-rand-100 leading-none pl-1 ml-1">{roundedSafeDiscount} %
              </span>}
        </div>
        <div className={`mt-1 leading-none ${mobile ? "h-[10px]" : "h-[16px]"}`}>
          {!!roundedSafeDiscount &&
          <div
            className={`${mobile ? "text-[9px]" : "text-xs"} text-center space-x-1 whitespace-nowrap`}>
            <span className="line-through">NPR. {product.price}</span>
            <span>Save NPR. {product.price}</span>
          </div>
          }
        </div>
        {((!isFlashSale && mobile) || hideButton) &&
        <div className={`${mobile ? "space-x-2" : "space-x-4"} flex text-center mt-2`}>
          <HeartSvg className={mobile ? "w-6" : "w-8"}/>
          <div
            className={`app-rounded bg-primaryApp px-2 ${mobile ? "py-1.5 text-xxs" : "py-2.5 text-base"} leading-none flex-1 text-white`}>Add
            to
            Cart
          </div>
        </div>
        }

        {isFlashSale &&
        <div className="mt-1.5">
          <div className="text-right text-xxs leading-none mb-0.5">
            10 left
          </div>
          <div className="h-[5px] w-full bg-rand-300 rounded-l-full rounded-r-full">
            <div className="bg-primaryApp h-full rounded-l-full rounded-r-full w-1/3"/>
          </div>
        </div>
          }


      </div>

    </div>
  );
};

export default ProductCard;

const StarPoints = ({rating, mobile, id = "", totalStars = 5}) => {

  const safeRating = Math.min(parseFloatSafe(rating), totalStars);
  return (
    <>
      {/* {Array.from({length: totalStars}, (_, i) => <CustomIcon key={`star-points-${i + 1}-${id}`}
                                                              icon={i + 1 <= safeRating ? <StarFillSvg
                                                                className={mobile ? "w-2.5" : "w-4"}/> : Math.round(safeRating) === i + 1 ?
                                                                <StarHalfSvg className={mobile ? "w-2.5" : "w-4"}/> :
                                                                <StarSvg className={mobile ? "w-2.5" : "w-4"}/>}/>)} */}

      <StarFillSvg className={`${mobile ? "w-2.5" : "w-3"} mr-1`}/>
    </>

  );
};

const ProductCardStarWidget = ({
                                 reviewAndRating,
                                 className,
                                 color,
                                 size,
  mobile,
                                 totalStars = 5

                               }) => {

  const safeRating = Math.min(reviewAndRating?.avg_rating ?? 0, totalStars);
  return (
    <>
      {!!reviewAndRating?.rating_count &&<div className={`flex text-xs sm:text-sm text-dark font-light px-2 py-1 sm:py-1.5 bg-white/75 leading-none sm:leading-none rounded-tr-[var(--border-radius)] ${className ?? 'space-x-0.5 sm:space-x-1'}`}>
        <StarFillSvg className={`${mobile ? "w-2.5" : "w-3"} mr-1`}/> <span className="font-medium mr-0.5">{toFixed(safeRating, 1)}/{totalStars}</span>
        ({reviewAndRating?.rating_count ?? 0})
      </div>
      }
    </>

  );
};



